import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import { makeStyles } from '@material-ui/core/styles';
import style from '../../assets/jss/eclipse/components/confirmDilogStyle';
import { Button } from '@material-ui/core';

const useStyles = makeStyles(style);

const ConfirmationDialog = ({ open, title, message, onCancel, onConfirm, cancelText = "Cancel", confirmText = "Try Again" }) => {
  const classes = useStyles();

  return (
    <Dialog open={open}>
      <div className={classes.dialogContent}>
        <h5 className={`${classes?.textLeft} m-t-0`}><b>{title}</b></h5>
        <p>{message}</p>
        <span className={classes.actionContainer}>
          <Button className={classes?.linkColor} onClick={onCancel}>{cancelText}</Button>
          <Button className={classes?.linkColor} onClick={onConfirm}>{confirmText}</Button>
        </span>
      </div>
    </Dialog>
  );
};

ConfirmationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  cancelText: PropTypes.string,
  confirmText: PropTypes.string,
};

export default ConfirmationDialog;
